import { z } from 'zod'
import { learnerLaunchRequestSchema, learnerLaunchResponseSchema } from './learning-learner-launch'
import type { LearnerLaunchRequest, LearnerLaunchResponse } from './learning-learner-launch'

export { learnerLaunchRequestSchema, learnerLaunchResponseSchema }
export type { LearnerLaunchRequest, LearnerLaunchResponse }

type JsonObject = Record<string, unknown>
const routeId = z.string().trim().min(1).max(180)
const slug = z.string().regex(/^[a-z0-9][a-z0-9-]{0,127}$/u)
const sha256 = z.string().trim().regex(/^(?:sha256:)?[a-f0-9]{64}$/u)
export const learningLearnerCourseAccessResponseSchema = z.object({
  courseId: routeId,
  canSee: z.boolean(),
  canAccess: z.boolean(),
  accessReason: z.enum(['ENTITLEMENT_REQUIRED', 'CONTENT_UNAVAILABLE']).nullable(),
  artifactId: routeId.optional(),
  courseRevision: sha256.optional(),
  policyHash: sha256.optional(),
}).strict()

export const learningLearnerCourseOutlineQuerySchema = z.object({
  moduleSlug: slug.optional(),
}).strict()

const learnerCourseModuleSchema = z.object({
  slug,
  meta: z.record(z.unknown()),
  quiz: z.null(),
  content: z.null(),
  activities: z.array(z.never()),
  payloadLoaded: z.literal(false),
}).strict()

export const learningLearnerCourseOutlineResponseSchema = z.object({
  course: z.record(z.unknown()),
  manifest: z.record(z.unknown()),
  modules: z.array(learnerCourseModuleSchema),
  sync: z.null(),
}).strict()

export type LearningLearnerCourseAccessResponse = z.infer<typeof learningLearnerCourseAccessResponseSchema>
export type LearningLearnerCourseOutlineQuery = z.infer<typeof learningLearnerCourseOutlineQuerySchema>
export type LearningLearnerCourseOutlineResponse = z.infer<typeof learningLearnerCourseOutlineResponseSchema>


export type LearnerCourseJson = JsonObject
